import useFetchLegacyInventoryStatus from '../../../core/apiHooks/useFetchLegacyInventoryStatus';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
const useInventoryStatus = () => {
    var _a;
    const { modelCode } = useAppSelector(selectCurrentVehicle);
    const { data } = useFetchLegacyInventoryStatus([{ modelCode }]);
    const inventoryStatus = !data ? '' : ((_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.inventoryStatus) || '';
    return { inventoryStatus };
};
export default useInventoryStatus;
